import { trpc } from '@/services/trpc';

export function useFAQMutation() {
  const utils = trpc.useUtils();

  const create = trpc.faqs.create.useMutation({
    onSuccess: async () => utils.faqs.findAll.invalidate(),
  });

  const update = trpc.faqs.update.useMutation({
    onSuccess: async (data, { id }) => {
      await Promise.all([
        utils.faqs.findAll.invalidate(),
        utils.faqs.findOne.invalidate({ id }),
      ]);
    },
  });

  const remove = trpc.faqs.delete.useMutation({
    onSuccess: async (data, { id }) => utils.faqs.findAll.invalidate(),
  });

  return {
    create,
    update,
    remove,
  };
}
